import type { RootState } from '@/app/store';
import type { Tags } from '@/features/tags/types/tags.types';

// Basic selectors
export const selectCreateSoftTagState = (state: RootState) =>
  state.createSoftTag;

export const selectNewSoftTags = (state: RootState): Tags[] =>
  state.createSoftTag.newSoftTags;

export const selectNewSoftTagsLoading = (state: RootState): boolean =>
  state.createSoftTag.loading;

// Validation selectors
export const selectValidationState = (state: RootState) =>
  state.createSoftTag.validation;

export const selectValidationLoading = (state: RootState): boolean =>
  state.createSoftTag.validation.loading;

export const selectValidationError = (state: RootState): string | null =>
  state.createSoftTag.validation.error;

export const selectValidationIsValid = (state: RootState): boolean | null =>
  state.createSoftTag.validation.isValid;
